// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__G-IMH","hideSideBar":"Sidebar_hideSideBar__3U1NY"};